import announcementRepository from "../../repositories/marketing/announcement.repository";
import loginService from "../login.service";

const isShowed = (announcementKey) => {
    const user = loginService.getUserAuthentication() || {};

    const isViewed = user.announcementsViewed?.includes(announcementKey);
    const isInactive = user.announcementsInactive?.includes(announcementKey);

    return isViewed || isInactive;
}

const updateLocalStorage = (announcementKey) => {

    const user = loginService.getUserAuthentication();

    const newAnnouncementsViewed = (user.announcementsViewed || []);
    newAnnouncementsViewed.push(announcementKey)

    const newUser = { ...user, announcementsViewed: newAnnouncementsViewed }
    loginService.refreshUserAuthentication(newUser);
}

const markViewedByKey = async (announcementKey, additionalInfo) =>
    announcementRepository.markViewedByKey(announcementKey, additionalInfo);

const markViewed = async (announcementKey, additionalInfo) =>
    markViewedByKey(announcementKey, additionalInfo)
        .then(() => updateLocalStorage(announcementKey));

const getPlatformUpdateDisplayStatus = async (announcementKey) =>
    announcementRepository.getPlatformUpdateDisplayStatus(announcementKey)
        .then(({ data }) => data?.value || data);

const dismissPlatformUpdateModal = async () =>
    announcementRepository.dismissPlatformUpdateModal();

const getAnnouncementAllowedDisplay = async (announcementKey, requestId = null) => {

    const user = loginService.getUserAuthentication() || {};

    const userId = user?.id;

    if (!userId)
        return { success: false };

    return announcementRepository.getAnnouncementAllowedDisplay(announcementKey, userId, requestId)
       .then(({ data }) => data)
}

const findByContext = async (context) => {
    const res = await announcementRepository.findByContext(context);
    return res.data;
}

export default {
    isShowed,
    updateLocalStorage,
    markViewedByKey,
    markViewed,
    getAnnouncementAllowedDisplay,
    getPlatformUpdateDisplayStatus,
    dismissPlatformUpdateModal,
    findByContext,
}